import React, { Component } from 'react';
import '../css/UserInstructions.css';


export class UserInstructions extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <div className="userInstructions">
                    {
                        this.props.activeSlot
                        &&
                        <h1>{this.props.activeSlot}</h1>
                    }
                    <b>{this.props.instructions}</b>
                 </div>
               
            </div>
        );
    }
}
